import React, { useMemo } from 'react';

import { MenuItem, Typography } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
// import ClearSortListIem from './ClearSortListIem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import SortIcon from '@material-ui/icons/Sort';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import { CheckRadio } from 'screens/home/tasksList/styles';
// import FilterDisplay from '../TeamPageFilters/FilterDisplay';
import styled, { css } from 'styled-components';
import {
  StyledTypography,
  StyledBox,
  StyledIconButton,
  withStyledHoverIcon,
  CustomStyledHoverIconButton,
  StyledTooltip,
  VerticallyCenterContainer,
} from 'styles/common';

import { TASK_TYPES_2 } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import { StyledCloseIcon, StyledIcon, UncheckedCircle } from 'constants/icons';
import theme from 'constants/theme';

import { ItemContainer, ScrollableContainer } from '../TeamPageFilters/styles';
import { clearOrderAction } from './orderByReducer';
import {
  DEPARTMENT_SORT_OPTION,
  LAST_ACTIVITY_DATE_SORT_OPTION,
  OWNER_SORT_OPTION,
  PRIMARY_POD_SORT_OPTION,
  STATUS_SORT_OPTION,
  DUE_ON_SORT_OPTION,
  GOAL_OBJECTIVE_SORT_OPTION,
  TASK_TITLE_SORT_OPTION,
  TEAM_SORT_OPTION,
  GOAL_NAME_SORT_OPTION,
  GOAL_PROGRESS_SORT_OPTION,
} from './sortDropdownOptions';

const StyledDropdownList = styled(DropdownList)`
  margin-top: 15px;
  ${(props) => css`
    &:after {
      content: ' ';
      width: 0px;
      height: 10px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 9px solid ${theme.palette.background.paper};
      display: inline-block;
      position: absolute;
      transform: rotate(180deg);
      left: 40%;
      top: -10px;
      z-index: 999;
    }
  `};
`;

const DropdownListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const ChildWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 400px;
  flex-direction: row;
  align-items: center;
  padding: 1rem 1rem;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  margin: 0 1.5rem;
`;

export const SortOptionContainer = styled(MenuItem)`
  padding-top: 1rem;
`;

function ClearSortListIem({ orderByDispatch }) {
  function clearSort() {
    orderByDispatch(clearOrderAction());
  }
  return (
    <SortOptionContainer onClick={clearSort}>
      <StyledTypography color="primary">Clear Sort</StyledTypography>
    </SortOptionContainer>
  );
}

function HeaderLabelIcons({ orderBy, headCell, order, className }) {
  return (
    <LabelIcons className={className}>
      <IconContainer>
        {(orderBy !== headCell.id || (orderBy === headCell.id && order === 'asc')) && (
          <StyledArrowDropUpIcon active={orderBy === headCell.id} />
        )}
      </IconContainer>
      <IconContainer>
        {(orderBy !== headCell.id || (orderBy === headCell.id && order === 'desc')) && (
          <StyledArrowDropDownIcon active={orderBy === headCell.id} />
        )}
      </IconContainer>
    </LabelIcons>
  );
}

const LabelIcons = styled.span`
  margin-top: -16px;
`;
const IconContainer = styled.div`
  width: 24px;
  height: 7px;
`;
const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)`
  color: ${(props) => (props.active ? '#535354' : '#cacaca')};
`;
const StyledArrowDropUpIcon = styled(ArrowDropUpIcon)`
  color: ${(props) => (props.active ? '#535354' : '#cacaca')};
`;

const StyledArrowUpIcon = withStyledHoverIcon(KeyboardArrowUp);
const StyledArrowDownIcon = withStyledHoverIcon(KeyboardArrowDown);

const DropdownOption = ({ optionKey, orderBy, order, createSortHandler, children }) => {
  const isOrdered = orderBy === optionKey;
  const onClick = createSortHandler(optionKey);
  const onClickAsc = createSortHandler(optionKey, 'asc');
  const onClickDesc = createSortHandler(optionKey, 'desc');
  const isDesc = orderBy === optionKey && order === 'desc';
  const isAsc = orderBy === optionKey && order === 'asc';

  return (
    <MenuItem
      onClick={onClick}
      // value={employee.value}
      style={{ padding: 0 }}
    >
      <DropdownListWrapper>
        <StyledBox width={1}>
          <ChildWrapper>
            <CheckRadio
              disableRipple
              checked={isOrdered}
              // style={{ marginLeft: '1rem' }}
              checkedIcon={<UncheckedCircle size="smallest" color="blue" />}
              icon={<UncheckedCircle size="smallest" color="textSecondary" />}
              color="blue"
            />
            <Typography style={{ marginLeft: '1rem' }} variant="body1">
              {children}
            </Typography>
            <StyledTooltip title={`${children}: Min to Max`}>
              <CustomStyledHoverIconButton
                circular
                color={isAsc ? 'primary' : 'textSecondary'}
                backgroundColor="white"
                borderColor={isAsc ? 'primary' : 'textSecondary'}
                leftGutter
                padding="xLarge"
                style={{ marginLeft: 'auto' }}
                onClick={onClickAsc}
              >
                <StyledArrowUpIcon
                  size="headerSmall"
                  hoverColor="#ffffff"
                  color={isAsc ? 'primary' : 'textSecondary'}
                />
              </CustomStyledHoverIconButton>
            </StyledTooltip>
            <StyledTooltip title={`${children}: Max to Min`}>
              <CustomStyledHoverIconButton
                circular
                color={isDesc ? 'primary' : 'textSecondary'}
                backgroundColor="white"
                borderColor={isDesc ? 'primary' : 'textSecondary'}
                leftGutter
                padding="xLarge"
                onClick={onClickDesc}
              >
                <StyledArrowDownIcon size="headerSmall" color={isDesc ? 'primary' : 'textSecondary'} />
              </CustomStyledHoverIconButton>
            </StyledTooltip>

            {/* {isOrdered ? (
              <HeaderLabelIcons headCell={{ id: optionKey }} orderBy={orderBy} order={order} />
            ) : null} */}
          </ChildWrapper>
          <Divider />
        </StyledBox>
      </DropdownListWrapper>
    </MenuItem>
  );
};

// custom filter display for sortdropdown

const SortFilterDisplay = React.forwardRef((props, ref) => {
  const { width, onClick, icon, name, selectedCount, className, isDisabled = false, onClear } = props;
  return (
    <ItemContainer
      className={className}
      width={width}
      justify="space-between"
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        border: `1px solid ${theme.palette.borders.lighterGrey}`,
        maxWidth: width,
      }}
    >
      <VerticallyCenterContainer
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '80%',
        }}
        container
        alignItems="center"
      >
        {/* <StyledIcon color="textSecondary" size="tiny">
          {icon}
        </StyledIcon> */}
        <StyledTypography
          // leftGutter={1}
          display="inline"
          weight={props.weight ?? null}
          color={!selectedCount > 0 ? 'textPrimary' : theme.palette.grey.main}
        >
          {'Sort by '}
        </StyledTypography>
        <StyledTypography
          leftGutter={0.5}
          display="inline"
          weight={props.weight ?? null}
          color={props.textColor ?? 'textPrimary'}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {name}
        </StyledTypography>
      </VerticallyCenterContainer>
      <VerticallyCenterContainer container alignItems="center">
        {onClear && selectedCount > 0 ? (
          <StyledTooltip title="Clear">
            <CustomStyledIconButton
              circular
              color="primary"
              backgroundColor="white"
              borderColor="primary"
              leftGutter
              padding="xLarge"
              onClick={onClear}
            >
              <StyledCloseIcon size="tiniest" color="primary" />
            </CustomStyledIconButton>
          </StyledTooltip>
        ) : null}

        <StyledIcon leftGutter={1} size="smallest" color="textSecondary">
          <ArrowDropDownRoundedIcon />
        </StyledIcon>
      </VerticallyCenterContainer>
    </ItemContainer>
  );
});

const CustomStyledIconButton = styled(StyledIconButton)`
  &.MuiIconButton-root.Mui-disabled {
    background-color: ${getColorFromKey('primary')};
  }
  &.MuiButtonBase-root {
    width: ${(props) => (props.size === 'big' ? '28px' : '24px')};
    height: ${(props) => (props.size === 'big' ? '28px' : '24px')};
  }
`;

const items = [
  GOAL_OBJECTIVE_SORT_OPTION,
  TEAM_SORT_OPTION,
  // GOAL_PROGRESS_SORT_OPTION, //goal only
  STATUS_SORT_OPTION,
  LAST_ACTIVITY_DATE_SORT_OPTION,
  DUE_ON_SORT_OPTION,
  PRIMARY_POD_SORT_OPTION,
  DEPARTMENT_SORT_OPTION,
  // GOAL_NAME_SORT_OPTION, //goal only
  OWNER_SORT_OPTION,
  // TASK_TITLE_SORT_OPTION //task only
  // TAGS_SORT_OPTION,
];

export default function TaskSortDropdown({
  createSortHandler,
  orderBy,
  order,
  orderByDispatch,
  width,
  setOpenedCustomMenus,
  isDisabled,
  selectedTaskType,
}) {
  // const isAnyOptionSelected = items.some(option => option.key === orderBy);
  const activeItems =
    useMemo(() => {
      if (selectedTaskType === TASK_TYPES_2.task) {
        return [
          GOAL_OBJECTIVE_SORT_OPTION,
          TEAM_SORT_OPTION,
          STATUS_SORT_OPTION,
          LAST_ACTIVITY_DATE_SORT_OPTION,
          DUE_ON_SORT_OPTION,
          PRIMARY_POD_SORT_OPTION,
          DEPARTMENT_SORT_OPTION,
          OWNER_SORT_OPTION,
          TASK_TITLE_SORT_OPTION, // task only
        ];
      }
      if (selectedTaskType === TASK_TYPES_2.goal) {
        return [
          GOAL_OBJECTIVE_SORT_OPTION,
          TEAM_SORT_OPTION,
          GOAL_PROGRESS_SORT_OPTION, // goal only
          STATUS_SORT_OPTION,
          LAST_ACTIVITY_DATE_SORT_OPTION,
          DUE_ON_SORT_OPTION,
          PRIMARY_POD_SORT_OPTION,
          DEPARTMENT_SORT_OPTION,
          OWNER_SORT_OPTION,
          GOAL_NAME_SORT_OPTION, // goal only
        ];
      }
    }, [selectedTaskType]) ?? [];
  const selectedSortOption = activeItems.find((item) => item.key === orderBy);
  return (
    <CustomMenu
      icon={
        <SortFilterDisplay
          width={width}
          icon={<SortIcon padding="1px" />}
          name={selectedSortOption ? selectedSortOption.label : ''}
          isDisabled={isDisabled}
          selectedCount={orderBy.trim().length ? 1 : 0}
          onClear={(e) => {
            e.stopPropagation();
            orderByDispatch(clearOrderAction());
            document.body.click();
          }}
        />
      }
      onOpen={() => {}}
      setOpenedCustomMenus={setOpenedCustomMenus}
      menuType="task_sort"
    >
      <StyledDropdownList>
        <ScrollableContainer>
          {activeItems.map(({ key, label }) => (
            <DropdownOption optionKey={key} createSortHandler={createSortHandler} order={order} orderBy={orderBy}>
              {label}
            </DropdownOption>
          ))}
        </ScrollableContainer>

        {/* <ClearSortListIem orderByDispatch={orderByDispatch} /> */}
      </StyledDropdownList>
    </CustomMenu>
  );
}
